"use client";

import Link from "next/link";
import { signOut, useSession } from "next-auth/react";

export function AuthNav() {
  const { data: session, status } = useSession();

  if (status === "loading") {
    return (
      <span className="text-xs text-teal-200/60" aria-hidden>
        …
      </span>
    );
  }

  if (!session?.user) {
    return (
      <div className="flex items-center gap-2">
        <Link
          href="/auth/signin"
          className="rounded-lg px-3 py-2 text-sm text-teal-100 transition hover:bg-white/10"
        >
          Sign in
        </Link>
        <Link
          href="/auth/register"
          className="rounded-lg border border-white/20 px-3 py-2 text-sm text-teal-100 transition hover:bg-white/10"
        >
          Register
        </Link>
      </div>
    );
  }

  const label =
    session.user.creatorSlug != null
      ? `@${session.user.creatorSlug}`
      : session.user.email ?? session.user.name ?? "Account";

  return (
    <div className="flex flex-wrap items-center justify-end gap-2">
      <span className="hidden max-w-[10rem] truncate text-xs text-teal-200/80 sm:inline">
        {label}
      </span>
      <Link
        href="/dashboard"
        className="rounded-lg px-3 py-2 text-sm text-teal-100 transition hover:bg-white/10"
      >
        Dashboard
      </Link>
      <button
        type="button"
        onClick={() => void signOut({ callbackUrl: "/" })}
        className="rounded-lg border border-white/20 px-3 py-2 text-sm text-teal-100 transition hover:bg-white/10"
      >
        Sign out
      </button>
    </div>
  );
}
